<template>
  <div class="item extens-page-item" @click="goToPage(item)">
    <div class="title">{{ title }} | {{ crearedDate }}</div>
    <div class="content">
      <div v-if="type == 'comment' && !edit" class="text" ref="comment"></div>
      <textarea
        v-select
        v-if="type == 'comment' && edit"
        ref="comment"
        @click.stop
        :value="item.data"
      />
      <span v-if="type == 'key'" class="label">{{ $t("general.value") }}</span>
      <textarea
        v-select
        v-if="type == 'key' && edit"
        class="text value"
        @click.stop
        :value="item.key"
      />
      <div v-if="type == 'key' && !edit" class="text">{{ item.key }}</div>
      <span v-if="type == 'key'" class="label">{{
        $t("general.content")
      }}</span>
      <textarea
        v-if="type == 'key' && edit"
        class="text"
        @click.stop
        ref="keyValue"
        :value="item.value"
      />
      <div v-if="type == 'key' && !edit" class="text" ref="key">
        {{ item.value }}
      </div>
      <div v-if="type == 'link'">
        <span class="label">{{ $t("files1.place") }}:</span>
        <div class="text">
          {{
            item.bookId == item.linkedTo.bookId
              ? ""
              : getBookName(item.linkedTo.bookId)
          }}
          | {{ $t("general.page") }}
          {{ item.linkedTo.letter }}
        </div>
        <div v-if="item.linkedTo.note">
          <span class="label">{{ $t("general.desc") }}</span>
          <div class="text">
            {{ item.linkedTo.note }}
          </div>
        </div>
        <!-- <baseIcon
          nameIcon="edit-extens"
          width="15"
          height="15"
          pathIcon="icons-ganeral"
          @click.stop="goToPage(item.linkedTo)"
        /> -->
      </div>
      <div class="image" v-if="type == 'marker'">
        <canvas ref="canvas" />
      </div>
    </div>
    <div class="flex icons">
      <baseIcon
        v-if="type != 'marker' && !edit"
        nameIcon="edit-extens"
        width="15"
        height="15"
        class="icon-extens icon-garbage-extens icon-edit-extens"
        pathIcon="icons-ganeral"
        @click.stop="editMode(item)"
      />
      <baseIcon
        v-if="!edit"
        nameIcon="icon-garbage-stroke"
        width="15"
        height="17"
        class="icon-extens icon-garbage-extens"
        pathIcon="icons-ganeral"
        @click.stop="remove(item)"
      />
      <baseIcon
        v-if="type == 'link'"
        nameIcon="link"
        width="15"
        height="15"
        class="icon-extens icon-link-extens icon-edit-extens"
        pathIcon="general"
        @click.stop="goToPage(item.linkedTo)"
      />
    </div>
    <div
      v-if="edit"
      @click="cancelMode"
      class="edit-mode icon-extens icon-garbage-extens otz-icon cancel"
    >
      F
    </div>
    <div
      v-if="edit"
      @click="editMode(item.id)"
      class="edit-mode icon-extens icon-garbage-extens otz-icon"
    >
      A
    </div>

    <BaseCleanPopup
      v-body
      :h="37"
      :winh="hUserExtens"
      :winw="wUserExtens"
      :noneOverlay="true"
      v-zindex
      v-if="showEditor"
      @close="closeAllExtens"
    >
      <template v-slot:header>
        <div class="flex-center-vh">
          {{
            type == "comment"
              ? $t("comments.comment")
              : type == "link"
              ? $t("links.link")
              : $t("keys.key")
          }}
        </div>
      </template>
      <add-user-exten
        :tabId="tabId"
        v-if="type == 'comment'"
        @close="showEditor = false"
        :note="editorItem"
        :book="getCurrentBook"
      />
      <add-user-key
        :tabId="tabId"
        v-else-if="type == 'key'"
        @close="showEditor = false"
        :item="editorItem"
        :book="getCurrentBook"
      />
      <add-user-link
        :tabId="tabId"
        v-else-if="type == 'link'"
        @close="closeAllExtens"
        :item="editorItem"
        :edit="true"
        @gotoitempage="(item) => $emit('click', item)"
        :book="getCurrentBook"
      />
    </BaseCleanPopup>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import * as bookData from "@/services/bookData.js";
// import addUserExten from "./addUserExten.vue";
const addUserExten = () => import("./addUserExten.vue");
import addUserKey from "./addUserKey.vue";
import addUserLink from "./addUserLink.vue";

import mixBook from "@/mixing/mixBook.js";

export default {
  mixins: [mixBook],
  components: { addUserExten, addUserKey, addUserLink },
  props: ["type", "item", "tabId", "searchTxt"],
  data() {
    return {
      imgSrc: "",
      showEditor: false,
      editorItem: null,
      canvas: "",
      hasChanges: false,
      canvasHeight: 0,
      canvasWidth: 405,
      edit: false,
    };
  },
  watch: {
    searchTxt: function (val) {
      this.setHtml(this.type, val);
    },
  },
  async mounted() {
    switch (this.type) {
      case "comment":
      case "key":
        this.setHtml(this.type);
        break;
      case "marker":
        this.setMarker();
        break;
    }
  },
  computed: {
    ...mapState("personalAdditionsTabs", ["addingLink"]),
    ...mapGetters("bookPersonalExtensions", ["getAddExtensType"]),
    ...mapGetters("books", ["getBookbyId"]),
    getCurrentBook() {
      return this.$store.state.tabs[this.tabId].book.toString();
    },
    title() {
      return this.$t("general.page") + " " + this.item.letter;
    },
    canvasStyle() {
      let style =
        "height:" +
        this.canvasHeight +
        "px;width:" +
        this.canvasWidth +
        "px;pointer-events:none";
      return style;
    },
    crearedDate() {
      let mydate = new Date(this.item.created);
      return mydate.toLocaleDateString();
    },
    wUserExtens() {
      switch (this.type) {
        case "comment":
          return 380;
          break;
        case "key":
          return 240;
          break;
        case "link":
          return 380;
          break;
      }
    },
    hUserExtens() {
      switch (this.type) {
        case "comment":
          return 330;
          break;
        case "key":
          return 240;
          break;
        case "link":
          return 280;
          break;
      }
    },
  },
  methods: {
    ...mapActions("bookPersonalExtensions", ["setModeEdit", "closeExtens"]),
    setHtml(type, searchTxt = "") {
      let htmlStr = "";
      let element = null;
      if (type == "comment") {
        htmlStr = this.item.data;
        element = this.$refs.comment;
      }
      if (type == "key") {
        htmlStr = this.item.value;
        element = this.$refs.key;
      }
      const txtToHiglight = searchTxt || this.searchTxt;
      if (txtToHiglight) {
        htmlStr = highlightString(htmlStr, txtToHiglight);
        element.innerHTML = htmlStr;
      } else element.innerHTML = htmlStr;
    },
    async setMarker() {
      let c = this.$refs.canvas;
      let ctx = c.getContext("2d");
      let img;

      try {
        img = await bookData.getImageObject(
          this.item.bookId,
          this.item.name,
          "image",
          false,
          {},
          null,
          this.item.position
        );

        let originWidth = img.imageMetaData.width || img.width;
        let originHeight = img.imageMetaData.height || img.height;
        let rat = img.width / originWidth;
        img = img.picture;

        let sx = this.item.x * rat;
        let sy = this.item.y * rat;
        let dWidth = this.item.width * rat;
        let dHeight = this.item.height * rat;
        let ix = 0;
        let iy = 0;
        let iw = this.item.width * rat;
        let ih = this.item.height * rat;
        c.height = this.item.height * rat;
        c.width = this.item.width * rat;
        /*  if (dWidth > this.canvasWidth) {
        ix = this.canvasWidth - dWidth;
      }
      else { */
        iw = this.canvasWidth;
        ih = ih * (this.canvasWidth / dWidth);
        c.height = ih;
        c.width = this.canvasWidth;
        //}
        ctx.drawImage(img, sx, sy, dWidth, dHeight, 0, 0, iw, ih);
      } catch (ex) {
        // alert(ex);
      }
    },
    getBookName(bookid) {
      let bk = this.getBookbyId(bookid);
      return bk.name;
    },
    editMode(item) {
      if (this.type != "marker") {
        this.showEditor = true;
        this.editorItem = item;
        // this.setModeEdit(item);
      }
    },
    closeAllExtens() {
      this.showEditor = false;
      this.closeExtens();
    },
    cancelMode() {
      this.edit = !this.edit;
    },
    async remove(id) {
      //mixing
      this.deleteExtensItem(this.item, this.type);
    },
    goToPage(item) {
      this.$emit("click", item);
    },
  },
};

function highlightString(htmlString, searchString) {
  if (!searchString) return htmlString;
  // Create a regular expression to match all occurrences of "XXX"
  const regex = new RegExp(searchString, "g");

  // Replace all occurrences of the search string with a highlighted version
  const highlightedString = htmlString.replace(
    regex,
    `<span style="background-color: yellow;">${searchString}</span>`
  );

  return highlightedString;
}
</script>

<style lang="scss" scoped>
.extens-page-item {
  .icons {
    top: 0;
    left: 0;
    position: absolute;
    svg {
      stroke: #b2b2b2;
      &:hover {
        stroke: var(--custom-color1);
      }
    }

    .icon-link-extens {
      opacity: 0.4;
    }
  }
  .image {
    canvas {
      width: 100% !important;
    }
  }

  .title {
    font-size: 10px;
    padding: 0;
    // margin-top: 7px;
  }

  .content {
    padding: 10px 0;
    font-size: 13px;
    line-height: 15px;
    .text {
      margin-bottom: 10px;
    }
    .value {
      height: 30px;
    }
    .label {
      color: #d1d1d1;
      font-size: 10px;
      line-height: 14px;
      // margin-bottom: 10px;
      display: block;
    }
  }
}
</style>
